import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/lib/translations";

const LangContext = createContext({
  lang: "es",
  setLang: () => {},
  t: translations.es,
});

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("gw_lang") || "es";
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    try {
      localStorage.setItem("gw_lang", l);
      document.documentElement.lang = l;
    } catch (_) {
      // ignore storage errors
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
